<template>
    <div class="dropload-root relative cursor-pointer">
        <div class="ds-field-trigger ds-schedule-store-selector-trigger" @click="openDropdown">
            <span class="ds-schedule-store-selector-value">
                <icon width="16" height="16" class="ds-schedule-store-selector-trigger-icon">
                    <IconMapPin />
                </icon>
                <span class="ds-schedule-store-selector-trigger-text">{{ currentDepartmentName }}</span>
            </span>
        </div>
        <div v-if="isOpen"
            class="absolute left-0 overflow-y-auto z-50 max-h-[630px] ds-dropdown-menu ds-schedule-store-selector-menu"
            v-click-outside="closeDropdown">
            <div class="p-2 ds-schedule-store-selector-search">
                <base-input v-model="searchInput" placeholder="Поиск" @update:model-value="search" />
            </div>
            <TreeNode v-for="dep in deps" :key="dep.id" :node="dep" @node-clicked="selectDep" />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import IconMapPin from '../../ui/icons/IconMapPin.vue'
import TreeNode from './TreeNode.vue'
import { useScheduleStore } from '@/stores/scheduleStore'
import { useDepartmentStore } from '@/stores/departmentStore'
import { useAuthStore } from '@/stores/authStore';

const departmentStore = useDepartmentStore()
const scheduleStore = useScheduleStore()
const authStore = useAuthStore()

const isOpen = ref(false)
const deps = ref()
const searchInput = ref("")
const tree = computed(() => departmentStore.departmentsTree)
const currentDepartmentName = computed(() => scheduleStore.currentDepartment?.name || 'Выберите магазин')

const openDropdown = () => {
    isOpen.value = true
    searchInput.value = ""
};

const closeDropdown = () => {
    isOpen.value = false
    searchInput.value = ''
    resetTree()
};

const resetTree = () => {
    deps.value = [...tree.value]
}

const selectDep = (dep) => {
    const selectedDepartment = departmentStore.myAllDepartments.find(item => item.id === dep.id)

    if(selectedDepartment) {
        scheduleStore.setCurrentDepartment(selectedDepartment)
        scheduleStore.fetchSchedule()
        scheduleStore.fetchTimeSheet()
        isOpen.value = false
        resetTree()
    }
}

async function getTree() {
    await departmentStore.fetchDepartmentsTree()
    resetTree()
}

function search() {
    deps.value = departmentStore.myAllDepartments.filter(item => item.name.toLowerCase().includes(searchInput.value.toLowerCase()))
}

onMounted(async () => {
    await getTree()
    if(!scheduleStore.currentDepartment) {
        scheduleStore.setCurrentDepartment(authStore.userInfo.department)
    }
    selectDep(scheduleStore.currentDepartment)
})
</script>
